<template>
    <transition :name="`slide--${direction}`" appear>
        <div class="fullscreen position--fixed display--flex background--default scroll" :style="cssProps">
            <slot />
        </div>
    </transition>
</template>

<script>
// packages
import { computed } from '@vue/composition-api';

export default {
    props: {
        direction: {
            type: String,
            default: 'up'
        },
        index: {
            type: Number,
            default: 9999
        }
    },
    setup ( props ) {
        const cssProps = computed( () => {
            return {
                '--index-value': props.index
            };
        });
        return { cssProps };
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Animations
    // =============================================================================
    .slide {
        &--down-enter-active,
        &--down-leave-active,
        &--up-enter-active,
        &--up-leave-active {
            @include transform( translateY( 0 ) );
            @include transition( transform .3s ease-in-out .1s, opacity .3s ease-in-out );
        }
        &--down-enter,
        &--down-leave-to,
        &--up-enter,
        &--up-leave-to  {
            @include transition( opacity .3s ease-in-out, transform .3s ease-in-out .1s );
            opacity: 0;
            will-change: transform, opacity;
        }
        &--down-enter,
        &--down-leave-to {
            @include transform( translateY( -100% ) );
        }
        &--up-enter,
        &--up-leave-to {
            @include transform( translateY( 200% ) );
        }
    }

    // =============================================================================
    // Style
    // =============================================================================
    .fullscreen {
        @include transform-position( 0, false, false, 0 );
        @include dimensions( 100%, 100vh );
        z-index: var( --index-value ); // TODO: devido a página de guião, caso houver refactor volta a 8.;
        overflow: auto;
    }
</style>